import getIsPhoneNumber from './getIsPhoneNumber';

/**
 * Formats the search text by replacing spaces with dashes if the text represents a phone number.
 *
 * @param {string} searchText - the input search text
 * @return {string} the formatted search text
 */
const getFormattedSearchText = (searchText: string) => {
  const isPhoneNumber = getIsPhoneNumber(searchText);
  return isPhoneNumber ? searchText.replace(/\s+/g, '-') : searchText; // Formats phone number to 555-555-5555
};

export default getFormattedSearchText;
